// src/MessageItem.js
import React from 'react';

function MessageItem({ message }) {
  const { text, sender, timestamp } = message; // timestamp er her et Firestore Timestamp-objekt
  const senderDisplay = sender === 'kunde' ? 'Kunde' : 'Selger';

  const itemStyle = {
    padding: '10px',
    margin: '5px 0',
    borderRadius: '5px',
    backgroundColor: sender === 'kunde' ? '#e1f5fe' : '#f1f8e9',
    textAlign: sender === 'kunde' ? 'left' : 'right',
  };

  const senderStyle = {
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '5px'
  };

  return (
    <div style={itemStyle} className={`message-item message-${sender}`}>
      <span style={senderStyle}>{senderDisplay}</span>
      {text}
      <span style={{fontSize: '0.7em', marginLeft: '10px', color: 'grey', display: 'block', marginTop: '5px'}}>
        (
          {/* KORRIGERT TIDSPUNKT-VISNING */}
          {timestamp && timestamp.toDate ? timestamp.toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : 'sender...'}
        )
      </span>
    </div>
  );
}

export default MessageItem;